// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"movieGroup_wrapper__3EqC8","genreHeader":"movieGroup_genreHeader__1d9r6"};